import account from "./account.jsx";
import addresses from "../../desktop/tabs/addresses.jsx";
import fav from "./fav.jsx";
import history from "../../desktop/tabs/history.jsx";
import main from "./main.jsx";
import wallet from "./wallet.jsx";

const tabs = { main, addresses, fav, history, wallet, account };

export default tabs;
